export default __webpack_public_path__ + "static/media/header_bg.f57cc089.jpg";